import { __decorate, __param } from 'tslib';
import { ViewContainerRef, TemplateRef, Inject, PLATFORM_ID, Directive, NgModule } from '@angular/core';
import { isPlatformServer, isPlatformBrowser, CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
let SSRExcludeDirective = class SSRExcludeDirective {
    constructor(viewContainer, templateRef, platformId) {
        this.viewContainer = viewContainer;
        this.templateRef = templateRef;
        this.platformId = platformId;
    }
    ngOnInit() {
        if (isPlatformServer(this.platformId)) {
            this.viewContainer.clear();
        }
        else {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
};
SSRExcludeDirective.ɵfac = function SSRExcludeDirective_Factory(t) { return new (t || SSRExcludeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
SSRExcludeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SSRExcludeDirective, selectors: [["", "ssrExclude", ""]] });
SSRExcludeDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: TemplateRef },
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
SSRExcludeDirective = __decorate([ __param(2, Inject(PLATFORM_ID))
], SSRExcludeDirective);

let BrowserExcludeDirective = class BrowserExcludeDirective {
    constructor(viewContainer, templateRef, platformId) {
        this.viewContainer = viewContainer;
        this.templateRef = templateRef;
        this.platformId = platformId;
    }
    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.viewContainer.clear();
        }
        else {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
};
BrowserExcludeDirective.ɵfac = function BrowserExcludeDirective_Factory(t) { return new (t || BrowserExcludeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
BrowserExcludeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BrowserExcludeDirective, selectors: [["", "browserExclude", ""]] });
BrowserExcludeDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: TemplateRef },
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
BrowserExcludeDirective = __decorate([ __param(2, Inject(PLATFORM_ID))
], BrowserExcludeDirective);

let SSRExcludeModule = class SSRExcludeModule {
};
SSRExcludeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SSRExcludeModule });
SSRExcludeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SSRExcludeModule_Factory(t) { return new (t || SSRExcludeModule)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SSRExcludeDirective, [{
        type: Directive,
        args: [{
                selector: '[ssrExclude]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.TemplateRef }, { type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BrowserExcludeDirective, [{
        type: Directive,
        args: [{
                selector: '[browserExclude]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.TemplateRef }, { type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SSRExcludeModule, { declarations: function () { return [SSRExcludeDirective,
        BrowserExcludeDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SSRExcludeDirective,
        BrowserExcludeDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SSRExcludeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [SSRExcludeDirective, BrowserExcludeDirective],
                exports: [SSRExcludeDirective, BrowserExcludeDirective]
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-ssr-exclude
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SSRExcludeModule, SSRExcludeDirective as ɵa, BrowserExcludeDirective as ɵb };

//# sourceMappingURL=ngx-ssr-exclude.js.map